import React, { useState, useEffect, useCallback, memo } from 'react';
import axios from 'axios';
import { Server, ChevronDown, ChevronUp } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ServerClock = memo(({ language = 'es' }) => {
  const [serverTime, setServerTime] = useState(null);
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('serverClockCollapsed') === 'true';
  });

  const fetchServerTime = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/server-time`);
      setServerTime(response.data);
    } catch (error) {
      console.error('Error fetching server time:', error);
    }
  }, []);

  useEffect(() => {
    fetchServerTime();
    const syncInterval = setInterval(fetchServerTime, 30000);
    const tickInterval = setInterval(() => {
      setServerTime(prev => {
        if (!prev) return prev;
        const newTimestamp = prev.timestamp + 1;
        const newDate = new Date(newTimestamp * 1000);
        return {
          ...prev,
          timestamp: newTimestamp,
          formatted: newDate.toISOString().slice(0, 19).replace('T', ' ') + ' UTC'
        };
      });
    }, 1000);
    return () => {
      clearInterval(syncInterval);
      clearInterval(tickInterval);
    };
  }, [fetchServerTime]);

  const toggle = () => {
    setCollapsed(prev => {
      localStorage.setItem('serverClockCollapsed', !prev);
      return !prev;
    });
  };

  if (!serverTime) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 bg-slate-800/90 backdrop-blur-sm text-white rounded-lg shadow-lg flex items-center text-sm overflow-hidden"
      data-testid="server-time-display"
      title={language === 'es' ? 'Hora del servidor (fichajes)' : 'Server time (clock-ins)'}
    >
      {!collapsed && (
        <div className="flex items-center gap-2 px-3 py-2">
          <Server className="w-4 h-4 text-green-400 shrink-0" />
          <span className="font-mono">{serverTime.formatted}</span>
        </div>
      )}
      <button
        onClick={toggle}
        className="flex items-center justify-center px-2 py-2 hover:bg-white/10 transition-colors"
        title={collapsed
          ? (language === 'es' ? 'Mostrar hora del servidor' : 'Show server time')
          : (language === 'es' ? 'Ocultar hora del servidor' : 'Hide server time')}
      >
        {collapsed
          ? <Server className="w-4 h-4 text-green-400" />
          : <ChevronDown className="w-4 h-4 text-slate-300" />}
      </button>
    </div>
  );
});

ServerClock.displayName = 'ServerClock';

export default ServerClock;
